<template>
  <div class="modals">
    <transition-group tag="div" >
      <Modal
        v-for="(modal,index) in modals"
        v-bind="modal"
        :id="modal.id"
        :clickHandler="modal.onClick"
        :key="index"
        @close="removeModal"
      ></Modal>
    </transition-group>
  </div>
</template>
<script>
import Modal from './Modal.vue';

export default {
  // :name="transitionName" :mode="transitionMode"
  components: {
    Modal
  },
  props: {
    transitionName: {
      type: String,
      default: 'list'
    },
    transitionMode: {
      type: String,
      default: 'in-out'
    },
    overlap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modals: this.$modalList.state
    };
  },
  methods: {
    removeModal(id) {
      this.$modalList.removeModal(id);
    }
  },
  created() {
    this.$modalList.settings.overlap = this.overlap;
  },
  watch: {
    overlap: function(newVal) {
      this.$modalList.settings.overlap = newVal;
    }
  }
};
</script>
<style lang="scss">

</style>
